import {Attributes} from 'platform/components';

import {CustomerResponseBodyV2} from '@dms/api/customer';

import {TestIdProps} from 'shared/web';

import {useCustomerInformationAttributes} from '../../hooks/useCustomerInformationAttributes';

interface CustomerContractAttributesProps extends TestIdProps {
  customer: CustomerResponseBodyV2;
  displayAftersalesVersion?: boolean;
  resourceId?: string;
  recordId?: string;
}

export function CustomerInformationAttributes(props: CustomerContractAttributesProps) {
  const attributes = useCustomerInformationAttributes(
    props.customer,
    props.displayAftersalesVersion,
    props.resourceId,
    props.recordId
  );
  return <Attributes rows={attributes} size="quarter" data-testid={props['data-testid']} />;
}
